import React, { Fragment, useEffect, useState } from 'react';

import clsx from 'classnames';

import './pagination.scss';

const Pagination = ({ handleChange, totalRecords, activePage, perPage }) => {
  const pageBound = 5;
  const [upperPageBound, setUpperPageBound] = useState(5);
  const [lowerPageBound, setLowerPageBound] = useState(0);
  const [prevActive, setPrevActive] = useState('disabled');
  const [nextActive, setNextActive] = useState(
    totalRecords > perPage ? '' : 'disabled'
  );

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(totalRecords / perPage); i++) {
    pageNumbers.push(i);
  }

  useEffect(() => {
    setNextActive(totalRecords > perPage ? '' : 'disabled');
    setPrevActive('disabled');
  }, [totalRecords]);

  const handleClick = (event) => {
    const listId = Number(event.target.id);
    if (listId === activePage) return;
    handleChange(listId);
    setPrevAndNextBtnClass(listId);
  };

  const setPrevAndNextBtnClass = (listid) => {
    let totalPage = Math.ceil(totalRecords / perPage);
    setNextActive('disabled');
    setPrevActive('disabled');
    if (totalPage === listid && totalPage > 1) {
      setPrevActive('');
    } else if (listid === 1 && totalPage > 1) {
      setNextActive('');
    } else if (totalPage > 1) {
      setNextActive('');
      setPrevActive('');
    }
  };

  const btnIncrementClick = () => {
    setUpperPageBound(upperPageBound + pageBound);
    setLowerPageBound(lowerPageBound + pageBound);

    const listId = upperPageBound + 1;
    handleChange(listId);
    setPrevAndNextBtnClass(listId);
  };

  const btnDecrementClick = () => {
    setUpperPageBound(upperPageBound - pageBound);
    setLowerPageBound(lowerPageBound - pageBound);
    const listId = upperPageBound - pageBound;
    handleChange(listId);
    setPrevAndNextBtnClass(listId);
  };

  const btnPrevClick = () => {
    if (prevActive === 'disabled') return;
    if ((activePage - 1) % pageBound === 0) {
      setUpperPageBound(upperPageBound - pageBound);
      setLowerPageBound(lowerPageBound - pageBound);
    }
    const listId = activePage - 1;
    handleChange(listId);
    setPrevAndNextBtnClass(listId);
  };

  const btnNextClick = () => {
    if (nextActive === 'disabled') return;
    if (activePage + 1 > upperPageBound) {
      setUpperPageBound(upperPageBound + pageBound);
      setLowerPageBound(lowerPageBound + pageBound);
    }
    let listId = activePage + 1;
    handleChange(listId);
    setPrevAndNextBtnClass(listId);
  };

  const renderPageNumbers = pageNumbers.map((number) => {
    if (number === 1 && activePage === 1) {
      return (
        <li
          key={number}
          className={clsx(activePage === number && 'active')}
          id={number}
        >
          <span id={number} onClick={handleClick}>
            {number}
          </span>
        </li>
      );
    } else if (number < upperPageBound + 1 && number > lowerPageBound) {
      return (
        <li
          key={number}
          id={number}
          className={clsx(activePage === number && 'active')}
        >
          <span id={number} onClick={handleClick}>
            {number}
          </span>
        </li>
      );
    }
  });

  let pageIncrementBtn = null;
  if (pageNumbers.length > upperPageBound) {
    pageIncrementBtn = (
      <li className="">
        <span onClick={btnIncrementClick}> &hellip; </span>
      </li>
    );
  }
  let pageDecrementBtn = null;

  if (lowerPageBound >= 1) {
    pageDecrementBtn = (
      <li className="">
        <span onClick={btnDecrementClick}> &hellip; </span>
      </li>
    );
  }

  const renderPrevBtn = (
    <li className={prevActive}>
      <span id="btnPrev">Prev</span>
    </li>
  );

  const renderNextBtn = (
    <li className={nextActive}>
      <span id="btnNext">Next</span>
    </li>
  );

  return (
    <Fragment>
      <div className="company-pagination">
        <span className="prev-btn" onClick={btnPrevClick}>
          {renderPrevBtn}
        </span>
        <ul>
          {pageDecrementBtn}
          {renderPageNumbers}
          {pageIncrementBtn}
        </ul>
        <span className="nxt-btn" onClick={btnNextClick}>
          {renderNextBtn}
        </span>
      </div>
    </Fragment>
  );
};

export default Pagination;
